import React from 'react'
import styles from './iconWrapper.module.scss'

interface IconsProps {
  icon: React.ReactChild
  sizes?: string
}

const IconWrapper: React.FC<IconsProps> = ({ icon, sizes }) => {
  return <span className={`${styles.icon} ${styles[`icon${sizes}`]}`}>{icon}</span>
}

export default IconWrapper
